module.exports = __webpack_public_path__ + "img/bg16.5c6c579c.jpg";